import { useFlag } from '@proton/unleash/useFlag';

export function useFlagsDriveSharingAdminPermissions() {
    return useFlag('DriveSharingAdminPermissions');
}
